import FileSaver from 'file-saver';
import JSZip from 'jszip';

import _ from 'lodash';

export type zipMedia = { blob: Blob; name: string };
export type ZipData = {
  lsImages: zipMedia[];
  buildingImages: zipMedia[];
  lsDocs: zipMedia[];
  buildingDocs: zipMedia[];
  //more images outside the image folder will be ignored
  lsMainImg: zipMedia;
  buildingMainImg: zipMedia;
  excel: zipMedia[];
};

//every file should be a json {name: title, blob:blob}
export const zipDocs = (
  dataDocs: { name: string; blob: Blob }[],
  zipName: string
) => {
  return new Promise((resolve, reject) => {
    let zip = new JSZip();
    if (dataDocs && dataDocs.length > 0) {
      dataDocs.forEach((doc) => {
        zip.file(doc.name, doc.blob, { base64: true });
      });
    }
    zip
      .generateAsync({ type: 'blob' })
      .then((content) => {
        FileSaver.saveAs(content, zipName);
      })
      .then((data) => {
        resolve(data);
      })
      .catch((error) => reject(error));
  });
};
